var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-alert", {
        staticClass: "mb-2",
        attrs: {
          closable: false,
          title: _vm.$t.__(
            "developerPage.WebhooksForms.Webhooks.WebhookSlack.add_webhook_error"
          ),
          type: "success"
        }
      }),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "div",
            { staticClass: "prelative mt-4" },
            [
              _c("preloader", {
                attrs: { background: false, display: _vm.loading }
              })
            ],
            1
          )
        : _c("webhooks-form-template", {
            attrs: { logs: _vm.logs, form: _vm.form, rules: _vm.rules },
            on: { submit: _vm.submit },
            scopedSlots: _vm._u([
              {
                key: "endpoint",
                fn: function() {
                  return [
                    _c(
                      "el-form-item",
                      {
                        attrs: { prop: "name", error: _vm.errors.name },
                        scopedSlots: _vm._u([
                          {
                            key: "label",
                            fn: function() {
                              return [
                                _c("span", { staticClass: "gray-100" }, [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.$l10n.__("Nom du webhook")) +
                                      "\n                    "
                                  )
                                ])
                              ]
                            },
                            proxy: true
                          }
                        ])
                      },
                      [
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex-row ai-center" },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.form.name,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "name", $$v)
                                },
                                expression: "form.name"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: { prop: "endpoint", error: _vm.errors.endpoint },
                        scopedSlots: _vm._u([
                          {
                            key: "label",
                            fn: function() {
                              return [
                                _c("span", { staticClass: "gray-100" }, [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.$l10n.__("Endpoint Slack")) +
                                      "\n                    "
                                  )
                                ])
                              ]
                            },
                            proxy: true
                          }
                        ])
                      },
                      [
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex-row ai-center" },
                          [
                            _c("i", { staticClass: "icon-link mr-2" }),
                            _vm._v(" "),
                            _c("el-input", {
                              model: {
                                value: _vm.form.endpoint,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "endpoint", $$v)
                                },
                                expression: "form.endpoint"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "mb-0",
                        attrs: {
                          prop: "default_channel",
                          error: _vm.errors.default_channel
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "label",
                            fn: function() {
                              return [
                                _c("span", { staticClass: "gray-100" }, [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.$l10n.__("Channel Slack par défaut")
                                      ) +
                                      "\n                    "
                                  )
                                ])
                              ]
                            },
                            proxy: true
                          }
                        ])
                      },
                      [
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex-row ai-center" },
                          [
                            _c("i", { staticClass: "fa fa-15 fa-slack mr-2" }),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "wp-5",
                              model: {
                                value: _vm.form.default_channel,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "default_channel", $$v)
                                },
                                expression: "form.default_channel"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "el-checkbox",
                          {
                            model: {
                              value: _vm.form.is_enabled,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "is_enabled", $$v)
                              },
                              expression: "form.is_enabled"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$l10n.__("Webhook actif ?")))]
                        )
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              },
              {
                key: "configDescription",
                fn: function() {
                  return [
                    _c("p", { staticClass: "mt-2 mb-4" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$l10n.__(
                              "Vous pouvez personnaliser pour chaque notification le channel Slack."
                            )
                          ) +
                          "\n            "
                      )
                    ])
                  ]
                },
                proxy: true
              },
              {
                key: "tagEvents",
                fn: function(scopeEvents) {
                  return [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.activeEvents(scopeEvents.currentLog.id)) +
                        " /\n            " +
                        _vm._s(
                          _vm.getAllEventsForParentLog(
                            scopeEvents.currentLog.id
                          ).length
                        ) +
                        "\n        "
                    )
                  ]
                }
              },
              {
                key: "events",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      [
                        _c(
                          "el-table",
                          {
                            staticClass: "b-1",
                            attrs: {
                              data: _vm.getEventsConfigByLog(scope.log.id),
                              stripe: ""
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: { prop: "label", width: "390" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function() {
                                      return [
                                        _c("span", { staticClass: "regular" }, [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.getTableTitleByLog(
                                                  scope.log
                                                )
                                              ) +
                                              "\n                            "
                                          )
                                        ])
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                true
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { label: "Channel" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "flex-level" },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fa fa-15 fa-slack mr-2"
                                            }),
                                            _vm._v(" "),
                                            _c("el-input", {
                                              model: {
                                                value: scope.row.channel,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "channel",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.channel"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: _vm.$t.__(
                                  "developerPage.WebhooksForms.Webhooks.activated"
                                ),
                                width: "65"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scopeEnabled) {
                                      return [
                                        _c("el-switch", {
                                          attrs: {
                                            value: scopeEnabled.row.is_enabled
                                          },
                                          on: {
                                            input: function(e) {
                                              return _vm.handleSwitch(
                                                e,
                                                scopeEnabled.row
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.getLogsChildByLog(scope.log.id), function(
                          childLog
                        ) {
                          return _c(
                            "div",
                            { key: childLog.id },
                            [
                              _c(
                                "el-table",
                                {
                                  staticClass: "b-1",
                                  attrs: {
                                    data: _vm.getEventsConfigByLog(childLog.id),
                                    stripe: ""
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: { prop: "label", width: "390" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "header",
                                          fn: function() {
                                            return [
                                              _c(
                                                "span",
                                                { staticClass: "regular" },
                                                [
                                                  _vm._v(
                                                    "\n                                    " +
                                                      _vm._s(
                                                        _vm.getTableTitleByLog(
                                                          childLog
                                                        )
                                                      ) +
                                                      "\n                                "
                                                  )
                                                ]
                                              )
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: { label: "Channel" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(scope) {
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "flex-level" },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa fa-15 fa-slack mr-2"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("el-input", {
                                                    model: {
                                                      value: scope.row.channel,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "channel",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.channel"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: _vm.$t.__(
                                        "developerPage.WebhooksForms.Webhooks.activated"
                                      ),
                                      width: "65"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(scopeEnabled) {
                                            return [
                                              _c("el-switch", {
                                                attrs: {
                                                  value:
                                                    scopeEnabled.row.is_enabled
                                                },
                                                on: {
                                                  input: function(e) {
                                                    return _vm.handleSwitch(
                                                      e,
                                                      scopeEnabled.row
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  ]
                }
              }
            ])
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }